'use client';

import { Button, Icon, TextPassage } from '@petsmart-ui/sparky';

import { type Promotion } from '@/entities/product';

type PromoItemProps = {
    promo: Promotion;
    onClickAction: () => void;
};

export const PromoItem = ({ promo, onClickAction }: PromoItemProps) => {
    return (
        <div className="promo-list__item" data-testid="promo-item">
            <div className="promo-list__item-icon">
                <Icon name="tag" data-testid="promo-icon" />
            </div>

            <div className="promo-list__item-text">
                <TextPassage>{promo.text}</TextPassage>

                {Boolean(promo.key) && (
                    <Button
                        type="button"
                        text="Details"
                        variant="link"
                        onClick={onClickAction}
                        className="promo-list__item-details"
                    />
                )}
            </div>
        </div>
    );
};
